import { IN_FLIGHT_UPLOAD_STATUSES } from "@/common/constants/autoDj"

export const uploadQueue = (state) => {
  return state.uploadQueue
}

export const isUploadInFlight = (state) => {
  return state.uploadQueue.some((media) => media.status === "uploading")
}

export const hasUploadsInFlight = (state) => {
  return state.uploadQueue.some((media) => IN_FLIGHT_UPLOAD_STATUSES.includes(media.status))
}

export const pendingUploads = (state) => {
  return state.uploadQueue.filter((media) => media.status === "pending")
}
